import LocaleProvider from "antd/lib/locale-provider";
import enUS from "antd/lib/locale-provider/en_US";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import { insertCurrentUserOnLogin } from "./common/usersService";
import Login from "./components/Login";
import "./index.css";
import Root from "./Root";

insertCurrentUserOnLogin();

const App = (
    <LocaleProvider locale={enUS}>
        <Login>
            <BrowserRouter>
                <Root />
            </BrowserRouter>
        </Login>
    </LocaleProvider>
);

ReactDOM.render(App, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js